import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserDistressScoreService {
  error = new Subject<string>();
  slug = '/user_distress_scores';
  resourceName = 'user_distress_scores';
  allDistresss?: any;
  distresssBetween?: any;

  constructor(private http: HttpClient) {}

  fetchAll(): any {
    if (!this.allDistresss) {
      this.allDistresss = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: any[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allDistresss;
  }

  clearCache() {
    this.allDistresss = null;
    this.distresssBetween = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(distress_score: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      distress_score,
    };
    return this.http.post<any>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, distress_score: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      distress_score,
    };
    return this.http.patch<any>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }

  getRag(distress) {
    let ragColour = '';

    if (+distress <3) {
      ragColour = 'green';
    } else if (+distress > 2 && +distress < 5) {
      ragColour = 'amber';
    } else {
      ragColour = 'red';
    }

    return ragColour;
  }

  getRangeforColor(colour: string) {
    let ragRange = '';
    if (colour == 'green') {
      ragRange = '0-2';
    } else if (colour == 'amber') {
      ragRange = '3-4';
    } else {
      ragRange = '≥5';
    }

    return ragRange;
  }
}
